var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 11.0848C6.40661 11.0848 5.11328 9.79151 5.11328 8.19817C5.11328 6.60484 6.40661 5.31151 7.99995 5.31151C9.59328 5.31151 10.8866 6.60484 10.8866 8.19817C10.8866 9.79151 9.59328 11.0848 7.99995 11.0848ZM7.99995 6.31151C6.95995 6.31151 6.11328 7.15817 6.11328 8.19817C6.11328 9.23817 6.95995 10.0848 7.99995 10.0848C9.03995 10.0848 9.88661 9.23817 9.88661 8.19817C9.88661 7.15817 9.03995 6.31151 7.99995 6.31151Z",
    fill: "#494C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 14.2115C5.4933 14.2115 3.12664 12.7448 1.49997 10.1982C0.793304 9.09818 0.793304 7.30484 1.49997 6.19818C3.1333 3.65151 5.49997 2.18484 7.99997 2.18484C10.5 2.18484 12.8666 3.65151 14.4933 6.19818C15.2 7.29818 15.2 9.09151 14.4933 10.1982C12.8666 12.7448 10.5 14.2115 7.99997 14.2115ZM7.99997 3.18484C5.84664 3.18484 3.78664 4.47818 2.34664 6.73818C1.84664 7.51818 1.84664 8.87818 2.34664 9.65818C3.78664 11.9182 5.84664 13.2115 7.99997 13.2115C10.1533 13.2115 12.2133 11.9182 13.6533 9.65818C14.1533 8.87818 14.1533 7.51818 13.6533 6.73818C12.2133 4.47818 10.1533 3.18484 7.99997 3.18484Z",
    fill: "#494C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.04ba1a53261009cad5780b35199afdf5.svg";
export { ForwardRef as ReactComponent };